import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { LangContext } from '../App';
import { useAuth } from '../contexts/AuthContext';
import Header from './Header';

const T = {
  fr: {
    nav: [
      { label: 'Tableau de bord', to: '/dashboard', icon: '🏠' },
      { label: 'Mon profil', to: '/my-profile', icon: '👤' },
      { label: 'Mes terres', to: '/my-lands', icon: '🌲' },
      { label: 'Mes réservations', to: '/my-reservations', icon: '📅' },
      { label: 'Mes chasses', to: '/my-hunts', icon: '🎯' },
      { label: 'Ma carte', to: '/my-map', icon: '🗺️' },
      { label: 'Mes crédits', to: '/my-credits', icon: '⭐' },
      { label: 'Mon abonnement', to: '/my-subscription', icon: '💎' },
      { label: 'Mes signalements', to: '/my-reports', icon: '🚨' },
      { label: 'Mes évaluations', to: '/my-reviews', icon: '🌟' },
      { label: 'Sécurité', to: '/security', icon: '🔒' },
    ],
  },
  en: {
    nav: [
      { label: 'Dashboard', to: '/dashboard', icon: '🏠' },
      { label: 'My profile', to: '/my-profile', icon: '👤' },
      { label: 'My lands', to: '/my-lands', icon: '🌲' },
      { label: 'My reservations', to: '/my-reservations', icon: '📅' },
      { label: 'My hunts', to: '/my-hunts', icon: '🎯' },
      { label: 'My map', to: '/my-map', icon: '🗺️' },
      { label: 'My credits', to: '/my-credits', icon: '⭐' },
      { label: 'My subscription', to: '/my-subscription', icon: '💎' },
      { label: 'My reports', to: '/my-reports', icon: '🚨' },
      { label: 'My reviews', to: '/my-reviews', icon: '🌟' },
      { label: 'Security', to: '/security', icon: '🔒' },
    ],
  },
};

const SIDEBAR_WIDTH = 220;

const s = {
  shell: {
    minHeight: '100vh',
    background: 'var(--couleur-fond)',
    color: 'var(--couleur-texte)',
    display: 'flex',
    flexDirection: 'column',
  },
  body: {
    display: 'flex',
    flex: 1,
  },
  sidebar: {
    width: SIDEBAR_WIDTH,
    minWidth: SIDEBAR_WIDTH,
    background: 'rgba(0,0,0,0.25)',
    borderRight: '1px solid rgba(255,255,255,0.07)',
    padding: '1.5rem 0',
    position: 'sticky',
    top: 0,
    height: '100vh',
    overflowY: 'auto',
    flexShrink: 0,
  },
  link: (active) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 20px',
    fontSize: '0.88rem',
    fontWeight: active ? 700 : 400,
    color: active ? 'var(--couleur-or)' : 'rgba(255,255,255,0.7)',
    background: active ? 'rgba(201,162,39,0.1)' : 'transparent',
    borderLeft: active ? '3px solid var(--couleur-or)' : '3px solid transparent',
    textDecoration: 'none',
    transition: 'background 0.15s, color 0.15s',
    cursor: 'pointer',
  }),
  icon: {
    fontSize: '1rem',
    width: 22,
    textAlign: 'center',
    flexShrink: 0,
  },
  main: {
    flex: 1,
    minWidth: 0,
    padding: '2rem',
  },
};

export default function PrivateLayout({ children }) {
  const { lang } = useContext(LangContext);
  const { utilisateur } = useAuth();
  const t = T[lang] || T.fr;
  const isAdmin = utilisateur?.user_type === 'admin';
  const hasLandsRole =
    utilisateur?.user_type === 'landowner' ||
    utilisateur?.user_type === 'farmer' ||
    (utilisateur?.roles || []).some(
      (r) => ['landowner', 'farmer'].includes(r.role) && r.active !== false
    );
  const navItems = t.nav.filter(({ to }) => {
    if (isAdmin && (to === '/my-subscription' || to === '/my-credits')) return false;
    // Landowner-only entries: hide for users without the landowner/farmer role.
    if (!hasLandsRole && (to === '/my-lands' || to === '/my-reservations')) return false;
    return true;
  });

  return (
    <div style={s.shell}>
      <Header />
      <div style={s.body}>
        <nav style={s.sidebar}>
          {navItems.map(({ label, to, icon }) => (
            <NavLink key={to} to={to} style={({ isActive }) => s.link(isActive)}>
              <span style={s.icon}>{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>
        <main style={s.main}>{children}</main>
      </div>
    </div>
  );
}
